import { Button } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { StandardButton } from "@/components/standard-button";

export default function YumlabCook() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["recipe", id],
    queryFn: async () => {
      const r = await fetch(`/api/recipes/${id}`);
      if (!r.ok) throw new Error("Not found");
      return r.json() as Promise<{
        id: number;
        title: string;
        steps: Array<{ id: number; text: string; idx: number; timer_sec: number | null }>;
      }>;
    },
  });
  const [i, setI] = useState(0);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "ArrowRight" || e.key === " ")
        setI((x) => Math.min((data?.steps.length ?? 1) - 1, x + 1));
      if (e.key === "ArrowLeft") setI((x) => Math.max(0, x - 1));
      if (e.key === "Escape") navigate(`/recipes/${id}`);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [data?.steps.length, id, navigate]);

  if (!data) return null;
  const step = data.steps[i];

  return (
    <div className="min-h-screen bg-ink text-background">
      <div className="mx-auto max-w-3xl px-6 py-12 space-y-6">
        <header className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <StandardButton
              onClick={() => navigate(`/`)}
              className="bg-mint text-ink hover:bg-mint/90"
            >
              Home
            </StandardButton>
            <div className="font-display text-xl">{data.title}</div>
          </div>
          <Button
            onClick={() => navigate(`/recipes/${id}`)}
            className="cartoony-btn rounded-full bg-bubblegum text-ink hover:bg-bubblegum/90"
          >
            Exit
          </Button>
        </header>
        <div className="text-3xl md:text-5xl leading-tight font-display">{step?.text}</div>
        <div className="flex items-center gap-4">
          <Button
            onClick={() => setI((x) => Math.max(0, x - 1))}
            variant="secondary"
            className="cartoony-btn rounded-full"
          >
            Prev
          </Button>
          <div className="text-lg opacity-80">
            Step {i + 1} / {data.steps.length}
          </div>
          <Button
            onClick={() => setI((x) => Math.min(data.steps.length - 1, x + 1))}
            className="cartoony-btn rounded-full bg-mango text-ink hover:bg-mango/90"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
